import Button from './Button';

function ContactCTA() {
  return (
    <section className="contact-cta" aria-labelledby="contact-cta-title">
      <div className="container contact-cta__inner">
        <div>
          <h2 id="contact-cta-title">Need a quote or have a question?</h2>
          <p>Share your gearbox or hydraulic repair details and we will follow up.</p>
        </div>
        <Button to="/contact" variant="outline-light">
          Get in Touch
        </Button>
      </div>
    </section>
  );
}

export default ContactCTA;
